// extracted by mini-css-extract-plugin
export var active = "_gy-7";
export var blink = "_gy-8";
export var dropDownSelector = "_gy-4";
export var dropDownWrapper = "_gy-3";
export var fakeCursor = "_gy-6";
export var fontSizeButton = "_gy-9";
export var formQuillEditor = "_gy-0";
export var pressed = "_gy-a";
export var qlBlank = "_gy-1";
export var textFormattingToolbar = "_gy-2";
export var textToolbarOption = "_gy-5";